module.exports = __webpack_public_path__ + "img/hike met vrienden.8979fb25.jpg";